import type { MockBranchReviewReport } from '.';

/**
 * Returns true if the review report is in a loading state. When no report
 * exists, it's not considered loading.
 * @example
 * ```ts
 * isReviewReportLoading(null); // false
 * isReviewReportLoading({ status: 'pending' }); // true
 * isReviewReportLoading({ status: 'completed' }); // false
 * ```
 */
export function isReviewReportLoading(report: MockBranchReviewReport | null): boolean {
  if (!report) return false;
  return report.status === 'pending' || report.status === 'processing';
}
